module.exports = __webpack_public_path__ + "static/media/dai.e7aa542b.png";